
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.438 4.883c-.454 0-.855-.102-1.204-.305a2.087 2.087 0 01-.796-.836 2.578 2.578 0 01-.282-1.21c0-.443.1-.842.297-1.196C.656.976.937.7 1.297.508 1.657.31 2.063.21 2.516.21c.448 0 .846.099 1.195.297.354.198.628.474.82.828.198.354.297.755.297 1.203 0 .443-.104.844-.312 1.203a2.19 2.19 0 01-.852.836 2.477 2.477 0 01-1.227.305zM2.483.984c-.437 0-.796.144-1.078.43-.281.287-.422.662-.422 1.125 0 .469.141.846.422 1.133.282.286.64.43 1.078.43.448 0 .813-.144 1.094-.43C3.86 3.38 4 3.002 4 2.539c0-.458-.14-.83-.422-1.117-.281-.292-.646-.438-1.094-.438zM13.11.563v2.164h-.773c-.167-.605-.409-1.06-.727-1.368-.312-.307-.76-.46-1.343-.46-.537 0-1.016.18-1.438.538-.417.355-.745.891-.984 1.61-.24.713-.36 1.578-.36 2.594 0 1.541.222 2.726.664 3.554.443.828 1.086 1.242 1.93 1.242.427 0 .776-.06 1.047-.18.27-.124.497-.32.68-.585.187-.266.364-.656.53-1.172h.774v2.234c-.49.13-.992.227-1.507.29-.51.067-1.073.101-1.688.101-1.323 0-2.323-.448-3-1.344-.677-.896-1.016-2.232-1.016-4.008 0-1.114.175-2.09.524-2.93.354-.838.872-1.486 1.555-1.945C8.659.44 9.474.211 10.422.211c.474 0 .911.026 1.312.078.401.047.86.138 1.375.274z","fill":"currentColor"}})])
          )
        }
      }
    